import { Injectable, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AuthService } from "@auth0/auth0-angular";

@Injectable({ providedIn: "root" })
export class AuthStateService {
  private readonly auth = inject(AuthService);

  readonly user = toSignal(this.auth.user$, { initialValue: null }); // ora pubblico

  readonly isAuthenticated = toSignal(this.auth.isAuthenticated$, {
    initialValue: null,
  });

  readonly auth0Id = computed(() => this.user()?.sub ?? null);

  login(target = '/'): void {
    this.auth.loginWithRedirect({ appState: { target } }).subscribe();
  }
 
  logout(): void {
    this.auth.logout({
      logoutParams: {
        returnTo: globalThis.location.origin,
        federated: true,
      },
    });
  }
}